import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import HistoryTrackingList from './HistoryTrackingList';
import HistoryWAFTrackingList from './HistoryWAFTrackingList';
import { SiteTitle } from "../SiteTitle";


function HistoryTrackBackground() {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <SiteTitle />

            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tracking tabs"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "blue",
                            }
                        }}
                    >
                        <Tab label="查看漏洞歷史紀錄" value="1" />
                        <Tab label="查看WAF歷史紀錄" value="2" />
                    </Tabs>
                </Box>
                <TabPanel value="1">
                    <HistoryTrackingList />
                </TabPanel>
                <TabPanel value="2">
                    <HistoryWAFTrackingList />
                </TabPanel>
            </TabContext>
        </div>
    );
}

export default HistoryTrackBackground;
